import { Directive, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { AdvizeoUiElementImportance } from './../../interfaces/AdvizeoUi.interface';

export type TooltipPosition = 'left' | 'right' | 'above' | 'below';

const IMPORTANCE_DELAYS: Record<AdvizeoUiElementImportance, number> = {
    [AdvizeoUiElementImportance.LOW]: 1000,
    [AdvizeoUiElementImportance.MEDIUM]: 400,
    [AdvizeoUiElementImportance.HIGH]: 0
};

@Directive({
    selector: '[advizeoTooltip]',
    exportAs: 'advizeoTooltip'
})
export class AdvizeoTooltipDirective extends MatTooltip {
    // This tooltip directive encapsulates the mat tooltip https://github.com/angular/components/blob/master/src/material/tooltip/tooltip.ts
    constructor() {
        super();
        this.tooltipClass = 'advizeo-tooltip';
        this.showDelay = IMPORTANCE_DELAYS[AdvizeoUiElementImportance.MEDIUM];
    }

    @Input()
    set advizeoTooltip(message: string | null | undefined) {
        this.message = message;
    }

    @Input()
    set advizeoTooltipPosition(position: TooltipPosition) {
        this.position = position;
    }

    @Input()
    set advizeoTooltipImportance(importance: AdvizeoUiElementImportance) {
        this.showDelay = IMPORTANCE_DELAYS[importance];
    }
}
